/**
 * getFormattedDate - Get a formatted date string in format MM/DD/YYYY
 *
 * @param {Date} date - the date to get the formatted string for
 *
 * @returns {string}
 */
export function getFormattedDate(date: Date): string {
	var year = date.getFullYear()

	var month = (1 + date.getMonth()).toString()
	month = month.length > 1 ? month : '0' + month

	var day = date.getDate().toString()
	day = day.length > 1 ? day : '0' + day

	return month + '/' + day + '/' + year
}
